import { render, staticRenderFns } from "./Relationship.vue?vue&type=template&id=7e95698c"
import script from "./Relationship.vue?vue&type=script&lang=js"
export * from "./Relationship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports